import { render } from "./Asset and Inventory Management Policy.vue?vue&type=template&id=9efac8e8&scoped=true"
const script = {}

import "./Asset and Inventory Management Policy.vue?vue&type=style&index=0&id=9efac8e8&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9efac8e8"]])

export default __exports__